module.exports = __webpack_public_path__ + "static/media/icon-library.0d9a7037.svg";